import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthGate from './AuthGate';
import './PythonCurriculumPage.css';

const GoCurriculumPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="curriculum-page">
      <div className="curriculum-header">
        <button className="curriculum-back" onClick={() => navigate('/')}>
          ← Back
        </button>
        <span className="curriculum-title">
          <img
            src="https://go.dev/favicon.ico"
            alt=""
            width="16"
            height="16"
          />
          Go Curriculum
        </span>
      </div>
      <div className="curriculum-content">
        <AuthGate>
          <iframe
            className="curriculum-iframe"
            src="/go-curriculum-content/index.html"
            title="Go Curriculum"
          />
        </AuthGate>
      </div>
    </div>
  );
};

export default GoCurriculumPage;
